import { AppProvider } from 'providers';

import { SecurityGuard } from 'components/SecurityGuard';
import { AppRoutes } from 'routes/Routing';

export function App() {
  return (
    <AppProvider>
      {/* <InjectCaptcha /> */}

      <SecurityGuard>
        <AppRoutes />
      </SecurityGuard>
    </AppProvider>
  );
}
